export function getTitle(lecture) {
  return encodeURIComponent('Seminaranmeldung: ' + lecture.title || '');
}

export function getRequestTitle(lecture) {
  return encodeURIComponent('Terminanfrage: ' + lecture.title || '');
}



// WEBPACK FOOTER //
// ./src/components/lecture/utils/get-title.js